/*
 * @Author: your name
 * @Date: 2021-03-16 20:14:20
 * @LastEditTime: 2021-03-16 20:39:54
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_phone\src\api\api.js
 */
import requests from "./config";
export const categoryList = (params) => {
  return requests({
    method: "get",
    url: "/api/product/category/list",
    params
  })
}
// 轮播图
export const getBanner = (params) => {
  return requests({
    method: "get",
    url: "/api/carousel/carousel",
    params
  })
}


// 产品系列
//通过类别Id获取对应的产品列表
export const getClassifyList = (params) => {
  return requests({
      method: "get",
      url: `/api/product/page`,
      params
  })
}
export const getCategoryList = (params) => {
  return requests({
      method: "get",
      url: `/api/article/news/category/list`,
      params
  })
}

// 根据产品id获取产品明细
export const getProductDetaile = (params) => {
    return requests({
        method: "get",
        url: `/api/product/detail/${params}`,
    })
}
// 根据title获取焦点图
export const carouselByTitle = (params) => {
    return requests({
        method: "get",
        url: `/api/carousel/carouselbytitle`,
        params
    })
}

export const getArticleList = (params) => {
  return requests({
      method: "get",
      url: `/api/article/brandnews/category/pagelist`,
      params
  })
}
